document.addEventListener('DOMContentLoaded', () => {
	const searchForms = document.querySelectorAll('[data-sd-search="true"]');

	searchForms.forEach((form) => {
		const input = form.querySelector('.sd-search-field__input');
		const postTypesAttr = form.getAttribute('data-post-types');
		const taxonomyFiltersAttr = form.getAttribute('data-taxonomy-filters');

		if (!input || !postTypesAttr) return;

		let postTypes;
		let taxonomyFilters;

		try {
			postTypes = JSON.parse(postTypesAttr);
		} catch (e) {
			postTypes = ['post'];
		}

		try {
			taxonomyFilters = JSON.parse(taxonomyFiltersAttr);
		} catch (e) {
			taxonomyFilters = [];
		}

		// Store data on the input element for access in filters
		input.dataset.sdPostTypes = JSON.stringify(postTypes);
		input.dataset.sdTaxonomyFilters = JSON.stringify(taxonomyFilters);

		// Intercept form submission when taxonomy filters are present
		if (taxonomyFilters.length > 0) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				// Get current URL parameters
				const currentParams = new URLSearchParams(window.location.search);

				// Get search value
				const searchValue = input.value.trim();

				// Update or add the search parameter
				if (searchValue) {
					currentParams.set('sdlg_s', searchValue);
				} else {
					currentParams.delete('sdlg_s');
				}

				// Build new URL with merged parameters
				const newUrl = `${window.location.pathname}?${currentParams.toString()}`;

				// Navigate to new URL
				window.location.href = newUrl;
			});
		}
	});

	// Handle clicks on view-all link using event delegation
	document.addEventListener('click', (e) => {
		const viewAllItem = e.target.closest('.autosuggest__view-all');
		if (viewAllItem) {
			e.preventDefault(); // Prevent default link behavior
			e.stopPropagation(); // Prevent EP from handling this
			e.stopImmediatePropagation(); // Stop all other handlers

			const link = viewAllItem.querySelector('a');
			if (link && link.href) {
				window.location.href = link.href;
			}

			return false;
		}
	});

	// Modify the Elasticsearch query directly
	wp.hooks.addFilter(
		'ep.Autosuggest.query',
		'sd-search/autosuggest-query-filter',
		(query, searchText, input) => {
			// Only apply to our search inputs
			if (!input.classList.contains('sd-search-field__input') || !input.form) {
				return query;
			}

			const formData = new FormData(input.form);

			// Initialize post_filter if it doesn't exist
			if (!query.post_filter) {
				query.post_filter = {
					bool: {
						must: []
					}
				};
			}

			if (!query.post_filter.bool) {
				query.post_filter.bool = {
					must: []
				};
			}

			if (!query.post_filter.bool.must) {
				query.post_filter.bool.must = [];
			}

			// Add post type filters
			const postTypeValues = formData.getAll('post_type[]');
			if (postTypeValues.length > 0) {
				if (postTypeValues.length === 1) {
					// Single post type - use term query
					query.post_filter.bool.must.push({
						term: {
							'post_type': postTypeValues[0]
						}
					});
				} else {
					// Multiple post types - use terms query
					query.post_filter.bool.must.push({
						terms: {
							'post_type': postTypeValues
						}
					});
				}
			}

			// Add taxonomy filters
			// Get all form field names that end with []
			const taxonomyFields = new Set();
			for (let [key] of formData.entries()) {
				if (key.endsWith('[]') && key !== 'post_type[]') {
					taxonomyFields.add(key);
				}
			}

			// Process each taxonomy
			taxonomyFields.forEach(fieldName => {
				const taxonomy = fieldName.replace('[]', ''); // Remove the [] suffix
				const termIds = formData.getAll(fieldName).map(id => parseInt(id, 10));

				if (termIds.length > 0) {
					if (termIds.length === 1) {
						// Single term - use term query
						query.post_filter.bool.must.push({
							term: {
								[`terms.${taxonomy}.term_id`]: termIds[0]
							}
						});
					} else {
						// Multiple terms - use terms query
						query.post_filter.bool.must.push({
							terms: {
								[`terms.${taxonomy}.term_id`]: termIds
							}
						});
					}
				}
			});

			// console.log('ElasticPress Query:', JSON.stringify(query, null, 2));

			return query;
		}
	);

	// Customize individual autosuggest item HTML with thumbnail
	wp.hooks.addFilter(
		'ep.Autosuggest.itemHTML',
		'sd-search/sd-search-field',
		(html, result, input) => {
			// console.log('itemHTML', html, result, input);

			const postItem = result._source;
			const postType = postItem.post_type || 'post';
			const postTypeLabel = postItem.post_type_label || postType;
			const title = postItem.post_title || 'Untitled';
			const permalink = postItem.permalink || '#';

			// Get thumbnail
			let thumbnailHtml = '';
			if (postItem.thumbnail) {
				thumbnailHtml = `
                    <div class="autosuggest__thumbnail">
                        <img src="${postItem.thumbnail.src}" alt="${title}" loading="lazy" />
                    </div>
                `;
			} else {
				// Placeholder if no thumbnail
				thumbnailHtml = `
                    <div class="autosuggest__thumbnail autosuggest__thumbnail--placeholder">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                            <path d="M21 15L16 10L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                `;
			}

			// Get taxonomy terms if available
			let termsHtml = '';
			if (postItem.terms && Object.keys(postItem.terms).length > 0) {
				const termsArray = [];
				Object.values(postItem.terms).forEach(taxonomy => {
					if (Array.isArray(taxonomy)) {
						taxonomy.forEach(term => {
							if (term.name) termsArray.push(term.name);
						});
					}
				});

				if (termsArray.length > 0) {
					termsHtml = `<span class="autosuggest__terms">${termsArray.slice(0, 3).join(', ')}</span>`;
				}
			}

			// Optional: Display excerpt if available
			let excerptHtml = '';
			if (postItem.post_excerpt) {
				const excerpt = postItem.post_excerpt.length > 100
					? postItem.post_excerpt.substring(0, 100) + '...'
					: postItem.post_excerpt;
				excerptHtml = `<span class="autosuggest__excerpt">${excerpt}</span>`;
			}

			return `
                <li class="autosuggest-item" role="option" aria-selected="false" id="autosuggest-option-${input}">
                    <a href="${permalink}" class="autosuggest-link" data-search="${title}" data-url="${permalink}" tabindex="-1">
                        ${thumbnailHtml}
                        <div class="autosuggest__content">
                            <span class="autosuggest__title">${title}</span>
                            ${excerptHtml}
                            ${termsHtml}
                        </div>
                    </a>
                </li>
            `;
		}
	);

	// Add "View all results" link to the autosuggest list
	wp.hooks.addFilter(
		'ep.Autosuggest.listHTML',
		'sd-search/sd-search-field',
		(html, results, input) => {
			// console.log('ep.Autosuggest.listHTML', html, results, input);
			// Only apply to our search inputs
			if (!input.classList.contains('sd-search-field__input') || !input.dataset.sdPostTypes) {
				return html;
			}

			// Get the current search term
			const searchTerm = input.value.trim();

			if (!searchTerm) {
				return html;
			}

			let postTypes;
			let taxonomyFilters;

			try {
				postTypes = JSON.parse(input.dataset.sdPostTypes);
			} catch (e) {
				postTypes = ['post'];
			}

			try {
				taxonomyFilters = JSON.parse(input.dataset.sdTaxonomyFilters);
			} catch (e) {
				taxonomyFilters = [];
			}

			// Build the URL with all search parameters
			const urlParams = new URLSearchParams();

			// Add search term
			urlParams.append('s', searchTerm);

			// Add post types
			postTypes.forEach(postType => {
				urlParams.append('post_type[]', postType);
			});

			// Build the URL with search parameter
			let searchUrl;

			if (taxonomyFilters.length > 0) {
				// If we have taxonomy filters configured, merge with current URL params
				const currentParams = new URLSearchParams(window.location.search);
				currentParams.set('sdlg_s', searchTerm);
				searchUrl = `${window.location.pathname}?${currentParams.toString()}`;
			} else {
				// Otherwise, use the form's action URL and let the form handle params
				const form = input.closest('form');
				const formAction = form ? form.action : window.location.origin + '/';
				const urlParams = new URLSearchParams();
				urlParams.append('s', searchTerm);

				// Add post types from hidden fields in the form
				const postTypeInputs = form.querySelectorAll('input[name="post_type[]"]');
				postTypeInputs.forEach(ptInput => {
					urlParams.append('post_type[]', ptInput.value);
				});

				searchUrl = `${formAction}?${urlParams.toString()}`;
			}

			// Create the "View all results" link using ElasticPress classes
			const viewAllLink = `
	               <li class="autosuggest-item autosuggest__view-all">
	                   <a href="${searchUrl}" class="autosuggest-link" data-search="View all results for ${searchTerm}" data-url="${searchUrl}" tabindex="-1">
	                       <span class="autosuggest__view-all-text">View all results for "${searchTerm}"</span>
	                       <svg class="autosuggest__view-all-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	                           <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	                       </svg>
	                   </a>
	               </li>
	           `;

			// Append the link to the existing HTML
			// The HTML is wrapped in a <ul>, so we add our item before the closing </ul>
			html += viewAllLink;

			return html;
		}
	);
});
